import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ErrorView extends Vue {
    @Prop({ default: 'error' })
    mode: 'error';

    @Prop()
    customIcon: string;

    get icon() {
        return this.customIcon || this.mode;
    }
}
